// extracted by mini-css-extract-plugin
export default {"wrapper":"council_wrapper__R2YA+","inside":"council_inside__fR+J9","links":"council_links__Gg61L"};